import { Directive, ElementRef, Input } from '@angular/core';

const CUSTOM_QUILL_REMOVE_CLASS = 'custom-quill-remove-class';

@Directive({
  selector: '[appQuillRemoveButtons]'
})
export class QuillRemoveButtonsDirective {
  /**
   * buttonsToRemove est un tableau de strings.
   * Chaque string représente une class d'un bouton de Quill
   * Voici les valeurs possibles :
   * - ql-bold
   * - ql-italic
   * - ql-underline
   * - ql-strike
   * - ql-blockquote
   * - ql-code-block
   * - ql-header
   * - ql-list
   * - ql-script
   * - ql-indent
   * - ql-direction
   * - ql-size
   * - ql-color
   * - ql-background
   * - ql-font
   * - ql-align
   * - ql-clean
   * - ql-link
   * - ql-image
   * - ql-video
   *
   * Exemple d'intégration pour retirer les boutons d'ajout d'images et de vidéos :
   * <quill-editor appQuillRemoveButtons [buttonsToRemove]="['ql-image', 'ql-video']"></quill-editor>
   */
  @Input() public buttonsToRemove: any;
  @Input('appQuillRemoveButtons') public quillRemoveButtons: any;

  constructor(private el: ElementRef) {
    this.removeButtons(el);
  }

  private async removeButtons(quillRef: ElementRef): Promise<void> {
    setTimeout(() => {
      if (this.buttonsToRemove && Array.isArray(this.buttonsToRemove) && this.buttonsToRemove.length > 0) {
        quillRef.nativeElement.classList.add(CUSTOM_QUILL_REMOVE_CLASS);

        const style = document.createElement('style');
        style.innerHTML =
        `
          ${ this.buttonsToRemove.map(b => `.ql-toolbar .ql-formats .${b}`).join(', ') } {
            display: none;
          }
        `;
        quillRef.nativeElement.appendChild(style);
      }
    }, 0);
  }
}
